import { PublicKey } from "@solana/web3.js";

export const APT_MINT = new PublicKey("APTtJyaRX5yGTsJU522N4VYWg3vCvSb65eam5GrPT5Rt");
